import React, { createContext, useEffect, useRef, useState } from "react";
import * as _ from "lodash";
import axios from "axios";
import { authentication } from "../store/firebase-config";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useUserAuth } from "./UserAuthContext";
const Context = createContext();

export const ContextProvider = ({ children }) => {
  const [contestImageGalleryContents, setContestImageGalleryContents] =
    useState([]);

  const contestScrollPositionRef = useRef(0);
  const showcaseScrollPositionRef = useRef(0);
  const [updateData, setUpdateData] = useState(1);
  const [timeTaken, setTimeTaken] = useState();
  const [promptInstall, setPromptInstall] = useState(null);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [transactionDetails, setTransactionDetails] = useState({});
  const [paymentFormDetails, setPaymentFormDetails] = useState({});
  const [paymentData, setpaymentData] = useState({});
  const ctstId = window.location.pathname.split("/")[3]?.replace(/\.html$/, "");
  const cmpId = window.location.pathname.split("/")[2]?.replace(/\.html$/, "");
  const [details, setDetails] = useState([]);
  const [contestContent, setContestContent] = useState([]);
  const [singleContestDetails, setSingleContestDetails] = useState({});
  const [campaignId, setcampaignId] = useState(cmpId);
  const [contestId, setContestId] = useState(ctstId);
  const [contestData, setContestData] = useState();
  const [showCase, setShowCase] = useState([]);
  const [data, setData] = useState("");
  const [pinData, setPinData] = useState({});
  const [terms, setTerms] = useState({});
  const [contestRules, setContestRules] = useState({});
  const [uploadSuccess, setUploadSucccess] = useState(false);
  const [campaignClosed, setCampaignClosed] = useState(false);
  const [campaignEntryClosed, setCampaignEntryClosed] = useState(false);
  const [uploadSuccessFile, setUploadSucccessFile] = useState({});
  const [isPrivate, setIsPrivate] = useState();
  const [campaignType, setCampaignType] = useState();
  const [conductedBy, setConductedBy] = useState();
  const [customLogin, setCustomLogin] = useState("");

  //const organizerName = window.location.href.split('/')[2].split('.')[0]
  const [whatsUpLink, setWhatsUpLink] = useState("");
  const organizerName = window.location.href
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const contestName = window.location.pathname
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const campaignName = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");
  const [underReview, setUnderReview] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [filterState, setFilterState] = useState("");
  const [validationCompleted, setValidationComplete] = useState(false);
  const [unAuthorizedUser, setUnAuthorizedUser] = useState(false);
  const [campaignSpecs, setCampaignSpecs] = useState({});
  const [scrollDownState, setScrollDownState] = useState(true);
  const [participantCount, setParticipantCount] = useState(new Map());
  const [selectedBackground, setSelectedBackground] = useState({});
  const [generatedPosterUrl, setGeneratedPosterUrl] = useState("");
  const [resultUrls, setResultUrls] = useState([]);
  const [loadingData, setLoadingData] = useState({});
  const [ocassionDataofEvent, setOcassionDataofEvent] = useState({});
  const [reportErrorPopup, setReportErrorPopup] = useState(false);
  const [userTrackingMap, setUserTrackingMap] = useState([]);
  const [clickedImg, setClickedImg] = useState(null);
  const [pageNumber, setPageNumber] = useState(2);
  const [likeMap, setLikeMap] = useState(new Map());
  const [hasMore, setHasMore] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [ads, setAds] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const campaignMetaData = {
    organizerName,
    campaignName,
    contestName,
  };
  const campaignDataFromLocal = {
    organizerUniqueText: localStorage?.getItem("organizerUniqueText"),
    campaignUniqueText: localStorage?.getItem("campaignUniqueText"),
  };
  const eventCheker = (obj) => {
    setContestData(obj);
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const preview = searchParams.get("preview");
  const [limit, setLimit] = useState(3);
  const [userIdToken, setUserIdToken] = useState();
  const { currentUser } = useUserAuth();
  const navigate = useNavigate();
  const token = userIdToken || currentUser?.accessToken;
  const location = useLocation();
  const [entryUploadResponse, setEnteryUploadResponse] = useState({});
  const [isPwa, setIsPwa] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [imageGalleryContents, setImageGalleryContents] = useState([]);
  const [showcasePageNumber, setShowcasePageNumber] = useState(1);
  const [showcaseInitialRender, setContestInitialEntry] = useState(false);
  const buildType = process.env.REACT_APP_BUILD_TYPE;
  useEffect(() => {
    let ifMobile = process.env.REACT_APP_BUILD_TYPE;
    if (ifMobile == "mob") {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);
  useEffect(() => {
    const mqStandAlone = "(display-mode: standalone)";
    if (navigator.standalone || window.matchMedia(mqStandAlone).matches) {
      setIsPwa(true);
    }
  }, []);
  // useEffect(() => {
  //   if (organizerName !== "signup" && organizerName !== "profile") {
  //     if (preview) {
  //       if (currentUser) loadHomePageDetails(organizerName, campaignId);
  //     } else {
  //       if (_.isEmpty(details)) {
  //         loadHomePageDetails(organizerName, campaignId);
  //       }
  //     }
  //   }
  // }, [currentUser]);
  useEffect(() => {
    if (!_.isEmpty(details)) {
      loadCampaignSpecs(organizerName, campaignName);
    }
  }, [details]);
  const [showTHeBlackScreen, setshowTHeBlackScreen] = useState(false);
  const verifyUser = async () => {
    try {
      const idToken = await authentication.currentUser.getIdToken(true);
      setUserIdToken(idToken);
      return idToken;
    } catch (error) {
      console.log("error", error);
    }
  };
  const [blackScreen, setBlackScreen] = useState();
  useEffect(() => {
    setInterval(() => {
      verifyUser();
    }, 600000);
  }, []);
  useEffect(() => {
    if (preview) {
      if (!currentUser) {
        navigate(
          {
            pathname: `/signup`,
            search: "?preview=true",
          },
          { state: { previousLocation: location?.pathname } }
        );
      }
    }
  }, []);
  // const loadContestRules = async (organizerId, contestId, campaignId) => {
  //   try {
  //     const setApi = await axios.get(
  //       `${process.env.REACT_APP_HOW_TO_PARTICIPATE}_${organizerId}_${campaignId}_${contestId}.json`
  //     );
  //     setContestRules(setApi.data);
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  // const loadTermsAndConditions = async (organizerName, campaignName) => {
  //   try {
  //     const setApi = await axios.get(
  //       // `https://storage.googleapis.com/festivity_termsandconditions/tandc_${organizerId}_${campaignId}.json`,
  //       `${process.env.REACT_APP_TERMSANDCONDITION}/${organizerName}/${campaignName}/tandc.json`
  //     );
  //     // setTerms(setApi.data);
  //     setTerms(JSON.parse(JSON.stringify(setApi.data)));
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };
  const loadHomePageDetails = async (organizerId, campaignId) => {
    try {
      setDetails({});
      setUnderReview(false);
      setPageLoading(true);
      let config = {};
      if (preview) {
        config = {
          method: "get",
          url: `${process.env.REACT_APP_CAMPAIGNDETAILS_API}/${organizerId}/${campaignId}`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      } else {
        config = {
          method: "get",
          url: `${process.env.REACT_APP_CAMPAIGNDETAILS}/${organizerId}/${campaignId}/campaign.json`,
        };
      }
      let result = await axios(config);
      let sampleData = {};
      if (preview) {
        if (result?.data?.admin === false) {
          setUnAuthorizedUser(true);
        } else {
          sampleData = result?.data?.data;
        }
      } else {
        sampleData = result?.data;
      }

      setDetails(sampleData);
      if (!_.isEmpty(sampleData)) {
        localStorage.setItem("campaignId", sampleData?._id);
        localStorage.setItem("organizerId", sampleData?.orgId);
        localStorage.setItem("themeImage", sampleData?.themeImage);
        localStorage.setItem(
          "campaignUniqueText",
          sampleData?.campaignUniqueText
        );
        localStorage.setItem("organizerUniqueText", sampleData?.orgDomain);
      }
      setCustomLogin(sampleData?.loginBanner);
      setIsPrivate(sampleData?.isPrivate);
      setCampaignType(sampleData?.campaignType);
      setConductedBy(sampleData?.conductedBy);
      setWhatsUpLink(sampleData?.whatsup);
      if (sampleData?.campaignStatus === "CLOSED") {
        setCampaignClosed(true);
      }
      if (sampleData?.campaignStatus === "ENTRYCLOSED") {
        setCampaignEntryClosed(true);
      }
      let contestDetails =
        sampleData &&
        sampleData.contests &&
        sampleData.contests.filter((el) => {
          return el.contestUniqueText === contestId;
        });
      setSingleContestDetails(contestDetails);
      setFilterState(
        _.isEmpty(sampleData?.filterChips)
          ? "ALL"
          : sampleData?.filterChips[0]?.id
      );
      setPageLoading(false);
    } catch (err) {
      setPageLoading(false);
      setUnderReview(true);
      console.log(err.message);
    }
  };

  const loadCampaignSpecs = async (organizerName, campaignUniqueText) => {
    try {
      let config = {
        method: "get",
        url: `${process.env.REACT_APP_CAMPAIGNDETAILS}/${organizerName}/${campaignUniqueText}/campaignSpecs.json`,
        // url: `/campaignSpecs.json`,
      };
      let result = await axios(config);
      setCampaignSpecs(result?.data);
    } catch {
      setCampaignSpecs({});
    }
  };

  const getParticipantCounter = async (orgId, campaignId) => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_PARTICIPANT_COUNTER}/${orgId}/${campaignId}`,
    };
    let result = await axios(config);

    const dataMap = result?.data?.data?.reduce((map, item) => {
      map[item?.contestId] = item;
      return map;
    }, {});
    setParticipantCount(dataMap);
  };

  const handleUserTracking = (key, aditionalData) => {
    const updatedArray = userTrackingMap;
    let obj = {
      ts: new Date(Date.now()),
      atn: key,
      ...aditionalData,
    };
    updatedArray.push(obj);
    setUserTrackingMap(updatedArray);
  };

  const isDomainAllowed = async (email, allowedDomains) => {
    if (!email || !email.includes("@")) return false;

    // Get domain part after @
    const domain = email?.split("@")[1].split(".")[0];

    // Check if domain matches any allowed domain
    return allowedDomains.includes(domain?.toLowerCase());
  };

  return (
    <Context.Provider
      value={{
        paymentFormDetails,
        contestImageGalleryContents,
        setContestImageGalleryContents,
        setPaymentFormDetails,
        contestData,
        setContestData,
        details,
        campaignSpecs,
        setcampaignId,
        showCase,
        verifyUser,
        userIdToken,
        paymentData,
        setpaymentData,
        contestContent,
        singleContestDetails,
        setSingleContestDetails,
        setContestId,
        contestId,
        eventCheker,
        data,
        transactionDetails,
        setTransactionDetails,
        setData,
        terms,
        // loadTermsAndConditions,
        // loadContestRules,
        contestRules,
        limit,
        showTHeBlackScreen,
        setshowTHeBlackScreen,
        setLimit,
        setContestContent,
        loadHomePageDetails,
        uploadSuccess,
        setUploadSucccess,
        campaignClosed,
        setShowCase,
        uploadSuccessFile,
        setUploadSucccessFile,
        organizerName,
        setPinData,
        pinData,
        isPrivate,
        campaignType,
        blackScreen,
        setBlackScreen,
        campaignMetaData,
        whatsUpLink,
        setWhatsUpLink,
        campaignEntryClosed,
        underReview,
        filterState,
        setFilterState,
        conductedBy,
        validationCompleted,
        setValidationComplete,
        preview,
        unAuthorizedUser,
        setUnAuthorizedUser,
        scrollDownState,
        setScrollDownState,
        getParticipantCounter,
        participantCount,
        campaignDataFromLocal,
        selectedBackground,
        selectedBackground,
        setSelectedBackground,
        generatedPosterUrl,
        setGeneratedPosterUrl,
        resultUrls,
        setResultUrls,
        loadingData,
        setLoadingData,
        ocassionDataofEvent,
        setOcassionDataofEvent,
        entryUploadResponse,
        setEnteryUploadResponse,
        resultUrls,
        setResultUrls,
        setReportErrorPopup,
        reportErrorPopup,
        userTrackingMap,
        handleUserTracking,
        setUserTrackingMap,
        promptInstall,
        setPromptInstall,
        setDetails,
        clickedImg,
        setClickedImg,
        likeMap,
        setLikeMap,
        pageNumber,
        setPageNumber,
        hasMore,
        setHasMore,
        viewMore,
        setViewMore,
        isPwa,
        pageLoading,
        setPageLoading,
        isMobile,
        selectedCoupons,
        setSelectedCoupons,
        coupons,
        setCoupons,
        ads,
        setAds,
        loadCampaignSpecs,
        contestScrollPositionRef,
        showcaseScrollPositionRef,
        updateData,
        setUpdateData,
        timeTaken,
        setTimeTaken,
        imageGalleryContents,
        setImageGalleryContents,
        showcasePageNumber,
        setShowcasePageNumber,
        showcaseInitialRender,
        setContestInitialEntry,
        buildType,
        customLogin,
        setCustomLogin,
        isDomainAllowed,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
